import ErrorPage from "../ErrorPage/ErrorPage";

const PageNotFound = () => <ErrorPage code={404} message="Page Not Found"/>

export default PageNotFound;
